

export class AppError{
    constructor(public orginalError?: any) {
        
    }
}
